import styled from 'styled-components';
import { ChevronRight } from 'react-feather';

import { colours } from 'themes/default';

export const StyledCreateVoucherFormHeader = styled.div`
  position: relative;
  background-color: white;
  border-bottom: 1px solid ${colours.Greyscale.SilverGrey};
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
  transition: background-color 0.15s ease-in-out;
  justify-content: space-between;
  padding: 0 10px;
  margin-top: 10px;
  display: flex;
  cursor: pointer;

  &:hover {
    background-color: ${colours.Shades.BlueShade20};
  }
`;

export const StyledCreateVoucherForm = styled.div`
  background-color: ${colours.Greyscale.MistGrey};
  padding: 1px 16px 0 16px;
  border-radius: 4px;
`;

export const StyledChevronRight = styled(ChevronRight)`
  position: absolute;
  top: 25%;
  right: 20px;
  transform: ${(props) => (props.showCreateVoucherForm ? 'rotate(-90deg)' : 'rotate(90deg)')};
`;
